import { GetCycleItemInfoResponse } from '../api-services/get-cycle-item-info.service';
import { CatalogInfo } from './catalog-info.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * サイクル設定画面の商品情報クラス
 *
 * @export ItemInfo
 * @class ItemInfo
 */
export class ItemInfo {
  /** フラグ値 TRUE */
  public static readonly FLAG_TRUE = '1';
  /** フラグ値 FALSE */
  public static readonly FLAG_FASE = '0';
  /** 取扱生協 表示値 */
  public static readonly DISP_ALL_COOP_FALSE = '県別';

  mediumName: string;
  mediumType: string;
  classCode: string;
  className: string;
  middleClassName: string;
  smallClassName: string;
  categoryTagId: string;
  categoryTagName: string;
  tagList: { tagId: string; tagName: string }[];
  goodsName: string;
  standardName: string;
  supplyTaxWithoutStd: number;
  costPriceStandard: number;
  gprStd: string;
  supplyTaxWithoutSpc1: number;
  costPriceSpecial1: number;
  gprSpc1: string;
  supplyTaxWithoutSpc2: number;
  costPriceSpecial2: number;
  gprSpc2: string;
  allCoop: boolean;
  enableSet: boolean;
  pcode: string;
  relationPcode: string;
  coopCode: string;
  itemCode: string;
  janCode: string;
  largeClassName: string;
  payeeClient: string;
  orderClient: string;
  applyTermStart: string;
  applyTermEnd: string;
  goodsMemo: string;
  catalogInfoMap: { [key: string]: CatalogInfo };
  numSum: number;
  priceSum: number;
  tagSelectionList: {tagId: string; tagName: string}[];

  constructor(data: GetCycleItemInfoResponse['CycleItemInfoList'][number],
    tagSelectionInfo: GetCycleItemInfoResponse['TagSelectionInfo']
  ) {
    this.mediumName = data.MediumName;
    this.mediumType = data.MediumType;
    this.classCode = data.ClassCode;
    this.className = data.ClassName;
    this.middleClassName = data.MiddleClassName;
    this.smallClassName = data.SmallClassName;
    this.categoryTagId = data.CategoryTagId;
    this.categoryTagName = data.CategoryTagName;
    this.tagList = data.TagInfoList.map(_ => ({
      tagId: _.TagId,
      tagName: _.TagName,
    }));
    this.goodsName = data.GoodsName;
    this.standardName = data.StandardName;
    this.supplyTaxWithoutStd = data.SupplyTaxWithoutStd;
    this.costPriceStandard = data.CostPriceStandard;
    this.gprStd = data.GprStd;
    this.supplyTaxWithoutSpc1 = data.SupplyTaxWithoutSpc1;
    this.costPriceSpecial1 = data.CostPriceSpecial1;
    this.gprSpc1 = data.GprSpc1;
    this.supplyTaxWithoutSpc2 = data.SupplyTaxWithoutSpc2;
    this.costPriceSpecial2 = data.CostPriceSpecial2;
    this.gprSpc2 = data.GprSpc2;
    this.allCoop = ItemInfo.FLAG_TRUE === data.AllCoop ? true : false;
    this.enableSet = ItemInfo.FLAG_TRUE === data.EnableSet ? true : false;
    this.pcode = data.Pcode;
    this.relationPcode = data.RelationPcode;
    this.coopCode = data.CoopCode;
    this.itemCode = data.ItemCode;
    this.janCode = data.JanCode;
    this.largeClassName = data.LargeClassName;
    this.payeeClient = data.PayeeClient;
    this.orderClient = data.OrderClient;
    this.applyTermStart = data.ApplyTermStart;
    this.applyTermEnd = data.ApplyTermEnd;
    this.goodsMemo = data.GoodsMemo;
    const obj: { [key: string]: CatalogInfo } = {};
    data.CatalogInfoList.forEach(_ => (obj[_.OrderCode] = new CatalogInfo(_)));
    this.catalogInfoMap = obj;
    this.numSum = data.NumSum;
    this.priceSum = data.PriceSum;
    for(let i = 0; i < tagSelectionInfo.length; i++) {
      if(tagSelectionInfo[i].ClassCode === this.classCode) {
        this.tagSelectionList = tagSelectionInfo[i].TagSelectionList.map(_ => {
          return {tagId:_.TagId, tagName: _.TagName}
        });
      }
    }
  }

  /** 表示用 タグ名 */
  get dspTagNames() {
    const txt = this.tagList
      .filter(_ => _)
      .filter(_ => this.categoryTagId !== _.tagId)
      .map(_ => _.tagName)
      .join(',');
    if (!txt) return '';
    return txt;
  }

  /** 表示用 取扱生協 */
  get dspAllCoop() {
    return this.allCoop ? '' : ItemInfo.DISP_ALL_COOP_FALSE;
  }

  /** 表示用 個数集計 */
  get dspNumSum() {
    return PlessViewUtilsSub.editPriceComma(this.numSum, true);
  }

  /** 表示用 金額集計 */
  get dspPriceSum() {
    return PlessViewUtilsSub.editPriceComma(this.priceSum, true);
  }
}
